import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Best-effort lock to portrait (works in installed PWA / fullscreen contexts).
function lockPortrait() {
  try {
    if (window.screen && window.screen.orientation && window.screen.orientation.lock) {
      window.screen.orientation.lock("portrait").catch(function () {});
    }
  } catch (e) {}
}
lockPortrait();
window.addEventListener("orientationchange", lockPortrait);
window.addEventListener("click", lockPortrait, { once: true });
window.addEventListener("touchend", lockPortrait, { once: true });
